
import styled from "styled-components";
import { breakpoints, size, theme } from "../../../../helpers/theme";
import { ReactComponent as Copy } from "../../../../assets/icons/copy.svg";

import { AdSmallTextBar, KContactBox } from '../../faq/styles';
import Icon from "../../../../components/icon";



export interface ContactAreaProps {
    boxTitle: string,
    boxPhone: string,
    boxPhone2?: string,
    boxPhone3?: string,
    boxPhone4?: string,
    boxPhone5?: string,
    boxMail: string,
};


export const ContactArea = ({ boxTitle, boxPhone, boxMail, boxPhone2, boxPhone3, boxPhone4, boxPhone5 }: ContactAreaProps) => {
    return (
        <Container>
            <Title>{boxTitle}</Title>
            <Content>
                {boxPhone2
                    ?
                    <>
                        Tel. {boxPhone} <br />
                        Tel. {boxPhone2}<br />
                        Tel. {boxPhone3}<br />
                        Tel. {boxPhone4}<br />
                        Tel. {boxPhone5}<br />
                        Mail. {boxMail}
                    </>
                    :
                    <>
                        Tel. {boxPhone}
                        <br />
                        Mail. {boxMail}
                    </>}

            </Content>
        </Container>
    )
};

const Title = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: 700;
font-size: 18px;
line-height: 22px;
color: ${theme.colors.black_primaryText};
padding-bottom:21px;
@media (max-width:${size.laptop}) {
    padding-left: 24px;
}
`
const Content = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 24px;
color: ${theme.colors.black_primaryText};
@media (max-width:${size.laptop}) {
    padding-left: 24px;
}
`
const Container = styled.div`
display:flex;
flex-direction:column;
border: 1px solid #FFFFFF;
border-radius: 16px;
//padding-left:49px;
padding-top:40px;
padding-bottom:40px;
width:28%;
padding-left: 4%;

@media (max-width:${size.laptop}) {
    width: 100%;  
    padding-left: 0%;
    margin-bottom:24px;
    min-width:230px;
    max-width:300px;
}

`